import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { ApprovalAction } from '../hooks/useApprovalActions';

interface ConfirmActionDialogProps {
  action: ApprovalAction | null;
  submitting: boolean;
  onClose: () => void;
  onConfirm: (action: ApprovalAction) => void;
}

const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  action,
  submitting,
  onClose,
  onConfirm,
}) => (
  <Dialog open={action !== null} onClose={() => !submitting && onClose()}>
    <DialogTitle>
      {action === 'approve' ? 'Approve this request?' : 'Reject this request?'}
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        {action === 'approve'
          ? 'Approving will resume the workflow and notify the requester.'
          : 'Rejecting will cancel the workflow and notify the requester.'}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={submitting}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color={action === 'approve' ? 'primary' : 'error'}
        disabled={submitting}
        onClick={() => action && onConfirm(action)}
      >
        {submitting ? 'Submitting…' : action === 'approve' ? 'Approve' : 'Reject'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmActionDialog;
